import React, { useState } from 'react';
import { useGame } from '../context/GameContext';
import { Copy, Check, Radio, X } from 'lucide-react';

export default function StreamerOverlay() {
  const { streamerMode, toggleStreamerMode, run, activeCurse } = useGame();
  const [copied, setCopied] = useState(false);

  if (!streamerMode) return null;
  const code = run?.seed || null;
  const chatCmd = code ? `!slop ${code}` : '!slop ???';

  const copy = () => {
    navigator.clipboard?.writeText(chatCmd).then(() => {
      setCopied(true); setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div
      className="fixed bottom-4 left-4 z-40 flex items-stretch gap-2 pointer-events-auto"
      data-testid="streamer-overlay"
    >
      <div className="brutal-border-pink bg-black/90 backdrop-blur-sm p-3 min-w-[280px] brutal-shadow-pink">
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-[color:var(--pink)]">
            <Radio size={12} className="animate-pulse"/> LIVE · STREAMER MODE
          </div>
          <button
            className="text-[color:var(--text-dim)] hover:text-white"
            onClick={toggleStreamerMode}
            data-testid="streamer-overlay-close"
            title="Turn off Streamer Mode"
          >
            <X size={14}/>
          </button>
        </div>
        <div className="text-[10px] uppercase tracking-widest text-[color:var(--text-dim)]">CURRENT SEED</div>
        <div className="font-display font-black text-5xl text-[color:var(--neon)] tracking-widest leading-none" data-testid="streamer-seed">
          {code || 'IDLE'}
        </div>
        <div className="mt-2 flex items-center justify-between gap-2">
          <div className="brutal-border-dim px-2 py-1 flex-1">
            <div className="text-[9px] uppercase text-[color:var(--text-dim)]">CHAT COMMAND</div>
            <div className="font-mono text-lg text-[color:var(--pink)] font-bold" data-testid="streamer-chat-cmd">{chatCmd}</div>
          </div>
          <button className="brutal-btn text-xs px-2 py-2" onClick={copy} data-testid="streamer-copy-cmd">
            {copied ? <Check size={14}/> : <Copy size={14}/>}
          </button>
        </div>
        {activeCurse && (
          <div className="mt-2 text-[10px] uppercase text-[color:var(--red)]">CURSED · 2X TOKENS ON WIN</div>
        )}
      </div>
    </div>
  );
}
